import { CustomTooltip } from '@tcweb/connect-ui';
import { Component, JSX, Show } from 'solid-js';
import { IconType } from './constants';

export interface TreeActionProps {
  disabled?: boolean;
  icon: IconType;
  label: string;
  class?: string;
  onClick?(): void;
  /** Base data-testid for the action control. Defaults to `tree-action`. */
  testId?: string;
}

export const TreeAction: Component<TreeActionProps> = (
  props: TreeActionProps
): JSX.Element => {
  const testId = (): string => props.testId ?? 'tree-action';

  return (
    <CustomTooltip
      text={props.label}
      position={'bottom-start'}
      disableToolTip={props.disabled}
    >
      <div class={props.class}>
        <Show when={props.disabled}>
          <div
            data-testid={testId()}
            class="flex w-10 h-10 rounded-full items-center justify-center"
          >
            <i
              data-testid={`${testId()}-icon-disabled`}
              class={['icon-font', 'md', props.icon].join(' ')}
            />
          </div>
        </Show>
        <Show when={!props.disabled}>
          <button
            class="w-10 h-10 rounded-full hover:bg-base-100 items-center"
            data-testid={testId()}
            onClick={(event): void => {
              if (props.onClick) {
                event.stopPropagation(); // Prevent expand/collapse on action click
                props.onClick();
              }
            }}
          >
            <i
              data-testid={`${testId()}-icon`}
              class={['icon-font', 'md', props.icon].join(' ')}
            />
          </button>
        </Show>
      </div>
    </CustomTooltip>
  );
};

export default TreeAction;
